import { gql } from '@apollo/client';
export const GET_STATE = gql `
  query GetState {
    getState {
      officeTripsStatus
      activeTripRequestId
      suggestingTripRequestId
      nextTripRequestId
      officeTripStationId
      pollToken
      waitingActionPlannedTrips
      acceptedPlannedTrips
      forceCompletedTripRequestId
      forceUnassignedTripRequest {
        __typename
      }
      addressChangedTripRequest {
        __typename
      }
      costAdjustedTripRequest {
        __typename
      }
    }
  }
`;
export const POLL_STATE_CHANGE = gql `
  query PollStateChange($pollToken: String!) {
    pollStateChange(pollToken: $pollToken) {
      hasChanges
    }
  }
`;
